import axios from "./axios";

export const getCategories = async (credentials) => {
    const response = await axios.post("/category/list", credentials);
    return response.data;
};

export const getSubcategoryElements = async (subcategoryId, page = 1, limit = 20) => {
    const response = await axios.get(`/category/subcategory/${subcategoryId}/elements`, {
        params: { page, limit }
    });
    return response.data;
};

export const getChildSubcategories = async (parentId) => {
    const response = await axios.get(`/category/subcategory/${parentId}/children`);
    return response.data;
};

export const checkSubcategoryHasChildren = async (subcategoryId) => {
    const response = await axios.get(`/category/subcategory/${subcategoryId}/has-children`);
    return response.data;
};

export const getElementsInfo = async (elementIds, elementNames) => {
    const response = await axios.post('/category/elements/info', { elementIds, elementNames });
    return response.data;
};